export default {
  created () {
    if (this.$options.title) {
      document.title = this.$options.title || 'TAIE 特有生物研究保育中心植物標本館'
    }
  }
}
